import React, { useState, useEffect, useContext } from 'react'
import OriginsManagement from './OriginsManagement'
import OriginsDirect from './OriginsDirect'
import { AuthenticationContext } from '../../../Auth/authentication.context'
import { useBranding } from '../../../contexts/BrandingContext'
import OriginsDirectInstant from './originsDirectInstant'

const Index = () => {
  const { module } = useContext(AuthenticationContext)
  const { isGroupMode } = useBranding()
  const [userModule, setUSerModule] = useState('')

  useEffect(() => {
    if (module) {
      setUSerModule(module)
    }
  }, [module])

  if (isGroupMode) {
    return <OriginsManagement userModule='Origins Management' />
  }
  if (userModule === 'Origins Direct') {
    return <OriginsDirect userModule={userModule} />
  }
  if (userModule === 'Origins Management') {
    return <OriginsManagement userModule={userModule} />
  }
  if (userModule === 'Origins Direct Instant') {
    return <OriginsDirectInstant userModule={userModule} />
  }
  return <div>User has no System or unrecognized System.</div>
}

export default Index
